import { VISUAL_TESTING } from 'src/modules/constants';
import { Module, ModulesList } from 'src/modules/types';
import visualTesting from './index';
import visualThunk from './thunks';

// TODO :: better name for module
const module: ModulesList = {
  [VISUAL_TESTING]: {
    path: '/visualTesting/:prId',
    component: visualTesting,
    thunk: visualThunk,
  } as Module,
};

export default module;
